import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import TlajoLog from '../../../../../../Assets/Images/logo-02.png'
import KpiCustomGraphicBar from '../../../../Documents/ReportsCounters/components/KpiCustomGraphicBar'
import KpiCustomGraphicPie from '../../../../../../helpers/KpiCustomGraphicPie'

const monthsNames = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const ActivityWaterTruckRequestPdfTemplate = ({
  filters = {
    array_provider_id: null,
    groupBy: 'ALL',
    start_date: null,
    end_date: null,
    year: '2025',
    month: null,
    week: null,
  },
  setPdfController,
  pdfController = {
    loading: false,
    hideElements: false,
    notes: null,
  },
  counter = {
    counterByDateFilter: null,
    counterByDateFilterLines: null,
    counterByDateFilterOptions: null,
    cards: null,
    generated: null,
    resolved: null,
    effectiveness: null,
    pieGraphs: [],
  },
  periodSelected = null,
  groupBy = 'ALL',
  year = moment().format('YYYY'),
  providersName = [],
}) => {
  const contentRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)

  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      setPdfController((prev) => ({
        ...prev,
        loading: false,
        hideElements: false,
        notes: null,
      }))
    },
    pageStyle: `
        @media print {
          @page {
            size: A4 landscape !important;;
            margin: 2mm 5mm !important;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          .print-container {
            width: 100%;
          }
          .full-page {
            width: 100vw;
            height: 100vh;
            display: flex;
            page-break-after: always;
          }
          .half {
            flex: 1;
            box-sizing: border-box;
          }
          .kpi-graphics {
            canvas {
              width: 100% !important;
              height: 500px !important;
            }
          }
        }
        @media screen {
          .print-container {
            width: 100%;
          }
          .full-page {
            width: 100vw;
            height: 100vh;
            display: flex;
            margin-bottom: 24px;
          }
          .half {
            flex: 1;
            box-sizing: border-box;
          }
        }              
    `,
  })

  useEffect(() => {
    if (pdfController.loading) {
      setTimeout(() => {
        reactToPrintFn()
      }, 1000)
    }
  }, [pdfController.loading])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768) // Detectar vista móvil
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const getChartOptionsPie = (options, flagIsMobile) => {
    const baseOptions = options || {}

    let dataReturn = {
      ...baseOptions,
      plugins: {
        ...(baseOptions.plugins || {}),
        legend: {
          ...(baseOptions.plugins?.legend || {}),
          display: false,
        },
        datalabels: {
          ...(baseOptions.plugins?.datalabels || {}),
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 4,
          color: '#000',
          padding: 4,
          font: {
            size: 15,
          },
        },
      },
    }

    if (flagIsMobile) {
      dataReturn.plugins.datalabels.font.size = 15
    }

    return dataReturn
  }

  const getChartOptionsBar = (options, flagIsMobile) => {
    const baseOptions = options || {}

    let dataReturn = {
      ...baseOptions,
      plugins: {
        ...(baseOptions.plugins || {}),
        legend: {
          ...(baseOptions.plugins?.legend || {}),
          display: false,
          labels: {
            ...(baseOptions.plugins?.legend?.labels || {}),
            font: {
              size: 9,
              weight: 'bold',
            },
          },
        },
        datalabels: {
          ...(baseOptions.plugins?.datalabels || {}),
          clamp: true, // Mantener dentro del canvas
          anchor: 'end',
          align: 'end',
          formatter: (value) => formatNumberWithCommas(value),
          offset: -10, // Ajuste fino para evitar que salga
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 4,
          color: '#000',
          padding: 4,
          font: {
            size: 10,
          },
        },
      },
      scales: {
        ...(baseOptions.scales || {}),
        x: {
          ...(baseOptions.scales?.x || {}),
          ticks: {
            ...(baseOptions.scales?.x?.ticks || {}),
            font: {
              size: 11,
              weight: 'bold',
            },
            callback: function (value) {
              return this.getLabelForValue(value).toUpperCase()
            },
          },
        },
        y: {
          ...(baseOptions.scales?.y || {}),
          ticks: {
            ...(baseOptions.scales?.y?.ticks || {}),
            font: {
              size: 11,
              weight: 'bold',
            },
            callback: function (value) {
              return String(value).toUpperCase()
            },
          },
        },
      },
    }

    if (flagIsMobile) {
      dataReturn.plugins.legend.labels.font.size = 6
      dataReturn.plugins.datalabels.font.size = 4
      dataReturn.scales.x.ticks.font.size = 5
      dataReturn.scales.y.ticks.font.size = 7
    }

    return dataReturn
  }

  return (
    <>
      <div ref={contentRef} className="print-container">
        <div className="full-page">
          <div className="half admin-master-mayor-pdf-template">
            <div
              className="d-flex flex-row w-100 justify-content-between align-items-center"
              style={{ gap: '10px 10px' }}
            >
              <div style={{ flex: 1 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <img src={TlajoLog} style={{ height: 50 }} />
                  </div>
                  <div>
                    <span style={{ fontSize: 16 }}>
                      {moment().format('DD/MM/YYYY')}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}></div>
            </div>

            <div className="d-flex flex-row w-100" style={{ gap: '10px 20px' }}>
              <div style={{ width: '55%' }}>
                <div
                  className="d-flex flex-row w-100"
                  style={{ gap: '10px 20px' }}
                >
                  <div style={{ width: 220, flex: 1 }}>
                    <BoxGeneral
                      periodSelected={periodSelected}
                      groupBy={groupBy}
                      year={year}
                      filters={filters}
                      providersName={providersName}
                    />

                    <div
                      className="d-flex flex-row flex-wrap justify-content-between"
                      style={{ gap: '0px 10px' }}
                    >
                      <BoxCardCounter cards={counter?.cards} />
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <BoxComments comments={pdfController?.notes} />
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <GraphicBarPipeRequest
                    counter={counter}
                    groupBy={groupBy}
                    isMobile={isMobile}
                    getChartOptionsBar={getChartOptionsBar}
                  />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <GraphicsPieLines
                  pieGraphs={counter?.pieGraphs}
                  isMobile={isMobile}
                  getChartOptionsPie={getChartOptionsPie}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const BoxGeneral = ({
  periodSelected,
  groupBy,
  year,
  filters,
  providersName,
}) => {
  return (
    <div className="mb-3" style={{ fontSize: 12 }}>
      <div className="d-flex">
        <div className="text-bold" style={{ width: 85 }}>
          Periodo:
        </div>
        <div style={{ flex: 1, fontStyle: 'italic' }}>
          {periodSelected === 'ALL' ? 'Generales' : 'Todos los registros'}
        </div>
      </div>

      <div className="d-flex">
        <div className="text-bold" style={{ width: 85 }}>
          Vista por:
        </div>
        <div style={{ flex: 1, fontStyle: 'italic' }}>
          {groupBy === 'year' && (
            <>
              <span className="subtitle">Año {year ? year.label : ''} </span>
              <br />
            </>
          )}
          {groupBy === 'week' && (
            <>
              <span className="subtitle">
                Año {year ? year.label : ''}
                Mes {monthsNames[filters.month - 1]} <br />
              </span>
            </>
          )}
          {groupBy === 'day' && (
            <>
              <span className="subtitle">
                Año {year ? year.label : ''} <br />
                Semana {filters.week} <br />
              </span>
            </>
          )}
          {groupBy === 'ALL' && (
            <span className="subtitle">Todos los registros</span>
          )}
        </div>
      </div>

      <div className="d-flex">
        <div className="text-bold" style={{ width: 85 }}>
          Proveedores:
        </div>
        <div style={{ flex: 1, fontStyle: 'italic' }}>
          {providersName?.length > 0 &&
            providersName?.map((providerName, index) => {
              const lastIndex = providersName.length - 1
              return (
                <span key={index} className="subtitle">
                  {providerName}
                  {index < lastIndex && <br />}                 
                </span>
              )
            })}
        </div>
      </div>
    </div>
  )
}

const BoxComments = ({ comments }) => {
  if (!comments) return <></>

  return (
    <div className="observations-box mb-4 px-2">
      <div className="header">
        <h5>Observaciones</h5>
      </div>
      <div className="body">{comments}</div>
    </div>
  )
}

const BoxCardCounter = ({ cards = [] }) => {
  if (!cards || cards?.length === 0) return <></>

  const length = cards.length

  return (
    <>
      {cards.map((card, index) => {
        return (
          <div style={length > 1 ? { flex: 1, minWidth: 100 } : {}} key={index}>
            <div style={{ width: '95%' }} className="card px-2 pt-2 pb-1">
              <div
                style={{
                  color: '#f97316',
                  backgroundColor: '#ffe1c7',
                  width: 30,
                  height: 30,
                  verticalAlign: 'middle',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '20%',
                  marginBottom: 8,
                }}
              >
                <i className="fas fa-times" style={{ fontSize: 16 }} />
              </div>
              <div
                style={{
                  fontSize: 12,
                  height: 25,
                  lineHeight: '14px',
                }}
              >
                {card.title}
              </div>
              <div style={{ fontSize: 35 }}>
                {card.value}
                {card?.percentage && (
                  <span
                    style={{
                      fontSize: 14,
                      color: '#4A4A4A',
                      fontWeight: 'bold',
                      marginLeft: 5,
                      backgroundColor: '#FFCDA2',
                      padding: '2px 5px',
                      borderRadius: '5px',
                    }}
                  >
                    ({card.percentage})
                  </span>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

const GraphicBarPipeRequest = ({
  counter,
  groupBy,
  isMobile,
  getChartOptionsBar,
}) => {
  if (!counter?.counterByDateFilter) return <></>

  return (
    <div className="graphics-box col-12 mt-2">
      <div className="header">
        <h5 className="text-left">
          Actividad de solicitudes de pipas{' '}
          {groupBy === 'day'
            ? 'por día'
            : groupBy === 'month'
            ? 'por mes'
            : groupBy === 'year'
            ? 'por año'
            : groupBy === 'week'
            ? 'por semana'
            : 'por todos los registros'}
        </h5>
      </div>
      <div className="body">
        <div className="legend-pdf">
          <div className="legend-item mr-2">
            <h5>Generados</h5>
            <p>{formatNumberWithCommas(counter?.generated)}</p>
          </div>
          <div className="legend-item mr-2">
            <h5>Resueltos</h5>
            <p>{formatNumberWithCommas(counter?.resolved)}</p>
          </div>
          <div className="legend-item">
            <h5>Efectividad</h5>
            <p>{Number(counter?.effectiveness).toFixed(2) || 0}%</p>
          </div>
        </div>
        <div className="chart" /* style={{ width: '50%', height: 300 }} */>
          <KpiCustomGraphicBar
            barDataStatus={counter?.counterByDateFilter}
            barOptions={{
              ...getChartOptionsBar(
                counter?.counterByDateFilterOptions,
                isMobile
              ),
            }}
            fromPdf={true}
            legendCustom={true}
          />
        </div>
      </div>
    </div>
  )
}

const GraphicsPieLines = ({ pieGraphs = [], getChartOptionsPie, isMobile }) => {
  if (!pieGraphs || pieGraphs.length === 1) return <></>

  const length = pieGraphs.length

  return (
    <div
      className="d-flex flex-row flex-wrap justify-content-around"
      style={{ gap: '20px 20px' }}
    >
      {pieGraphs.map((item, index) => (
        <div
          key={index}
          className="graphics-box px-2 pb-2"
          style={length < 3 ? { width: '100%' } : {}}
        >
          <div className="header">
            <h5 className="text-left">{item.title}</h5>
          </div>
          <div className="body">
            <div className="chart d-flex justify-content-center">
              <div style={{ width: 200 }}>
                <KpiCustomGraphicPie
                  pieDataStatus={item.pieDataStatus}
                  pieOptions={{
                    ...getChartOptionsPie(item?.pieOptions, isMobile),
                  }}
                  fromPdf={true}
                  legendCustom={true}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ActivityWaterTruckRequestPdfTemplate
